<mat-card-title mat-dialog-title class="d-flex align-items-center mb-0"
  ><mat-icon class="mr-2">insert_invitation</mat-icon>
  <div *ngIf="data.scheduleType === 'REASSIGN'">
    {{
      'submissions.reassign-and-reschedule-interview-popup.reassign-title'
        | translate
    }}
  </div>
  <div *ngIf="data.scheduleType === 'RESCHEDULE'">
    {{
      'submissions.reassign-and-reschedule-interview-popup.reschedule-title'
        | translate
    }}
  </div>
</mat-card-title>

<mat-card-subtitle
  ><div *ngIf="data.scheduleType === 'REASSIGN'">
    {{
      'submissions.reassign-and-reschedule-interview-popup.reassign-subtitle'
        | translate
    }}
  </div>
  <div *ngIf="data.scheduleType === 'RESCHEDULE'">
    {{
      'submissions.reassign-and-reschedule-interview-popup.reschedule-subtitle'
        | translate
    }}
  </div></mat-card-subtitle
>

<mat-divider class="mb-3"></mat-divider>

<div mat-dialog-content>
  <form [formGroup]="arrangeTechnicalInterviewFormGroup">
    <div class="row">
      <div class="col-md-12">
        <mat-form-field class="col-md pl-0 pr-1" appearance="fill">
          <mat-label>{{
            'submissions.reassign-and-reschedule-interview-popup.form.date'
              | translate
          }}</mat-label>
          <input
            matInput
            [matDatepicker]="startDatePicker"
            [placeholder]="
              'submissions.reassign-and-reschedule-interview-popup.form.date-placeholder'
                | translate
            "
            (click)="startDatePicker.open()"
            formControlName="date"
            [min]="minDate"
          />

          <mat-datepicker-toggle
            matSuffix
            [for]="startDatePicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #startDatePicker></mat-datepicker>
          <mat-error>{{
            'submissions.reassign-and-reschedule-interview-popup.form.required.date'
              | translate
          }}</mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <el-async-autocomplete
          label="{{
            'submissions.reassign-and-reschedule-interview-popup.form.interviewers'
              | translate
          }}"
          [filteredOptionsFromParent]="invitees"
          [selectionModes]="SELECTION_MODE.CHIPS"
          [size]="10"
          [total]="invitees.length"
          [isMultiSelectEnabled]="true"
          [selectedForEdit]="selectedUsers"
          [disabled]="true"
          [isRequired]="false"
          (selectedItems)="selectUser($event)"
          (asyncInput)="onFilterUsers($event)"
        >
        </el-async-autocomplete>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <mat-form-field appearance="fill">
          <mat-label>{{
            'submissions.reassign-and-reschedule-interview-popup.form.start-time'
              | translate
          }}</mat-label>
          <input
            placeholder="{{
              'submissions.reassign-and-reschedule-interview-popup.form.start-time-placeholder'
                | translate
            }}"
            matInput
            formControlName="from"
            [mtxDatetimepicker]="fromTimePicker"
            (click)="fromTimePicker.open()"
            [disabled]="false"
            required
          />
          <mtx-datetimepicker-toggle
            [for]="fromTimePicker"
            matSuffix
          ></mtx-datetimepicker-toggle>
          <mtx-datetimepicker
            #fromTimePicker
            type="time"
            startView="clock"
            color="primary"
            mode="portrait"
            [twelvehour]="true"
            [touchUi]="false"
          >
          </mtx-datetimepicker>
          <mat-error
            *ngIf="
              arrangeTechnicalInterviewFormGroup.controls.from.hasError(
                'required'
              )
            "
            >{{
              'submissions.reassign-and-reschedule-interview-popup.form.required.start-time'
                | translate
            }}</mat-error
          >
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field appearance="fill">
          <mat-label>{{
            'submissions.reassign-and-reschedule-interview-popup.form.end-time'
              | translate
          }}</mat-label>
          <input
            placeholder="{{
              'submissions.reassign-and-reschedule-interview-popup.form.end-time-placeholder'
                | translate
            }}"
            matInput
            formControlName="to"
            [mtxDatetimepicker]="toTimePicker"
            (click)="toTimePicker.open()"
            [disabled]="
              arrangeTechnicalInterviewFormGroup.controls.from.hasError(
                'required'
              )
            "
            required
          />
          <mtx-datetimepicker-toggle
            [for]="toTimePicker"
            matSuffix
          ></mtx-datetimepicker-toggle>
          <mtx-datetimepicker
            #toTimePicker
            type="time"
            startView="clock"
            color="primary"
            mode="portrait"
            [twelvehour]="true"
            [touchUi]="false"
            [disabled]="
              arrangeTechnicalInterviewFormGroup.controls.from.hasError(
                'required'
              )
            "
          >
          </mtx-datetimepicker>
          <mat-error
            *ngIf="
              arrangeTechnicalInterviewFormGroup.controls.to.hasError(
                'required'
              )
            "
            >{{
              'submissions.reassign-and-reschedule-interview-popup.form.required.end-time'
                | translate
            }}</mat-error
          >
          <mat-error
            *ngIf="
              arrangeTechnicalInterviewFormGroup
                .get('to')
                .hasError('invalidToDate')
            "
            >{{
              'rooms.popups.reserve.form.errors.to-validate' | translate
            }}</mat-error
          >
        </mat-form-field>
      </div>
    </div>
    <div class="row mb-1">
      <div class="col-md-12">
        <mat-radio-group
          formControlName="meeting_type"
          (change)="onMeetingTypeChange($event.value)"
        >
          <mat-radio-button
            class="mr-3"
            *ngFor="let option of meetingOptions"
            [value]="option.type"
          >
            {{ option.type }}
          </mat-radio-button>
        </mat-radio-group>
      </div>
    </div>

    <!-- Location Field  -->
    <div class="row" *ngIf="meetingType !== MEETING_OPTIONS.ONLINE">
      <div class="col-md-12">
        <mat-form-field style="width: 100%" appearance="fill">
          <mat-label>
            {{
              'submissions.arrange-technical-interview-popup.form.location'
                | translate
            }}
          </mat-label>
          <mat-select formControlName="location">
            <mat-option *ngFor="let location of locations" [value]="location">
              {{ location }}
            </mat-option>
          </mat-select>
          <mat-error
            *ngIf="
              arrangeTechnicalInterviewFormGroup.controls.location.hasError(
                'required'
              )
            "
          >
            {{
              'submissions.arrange-technical-interview-popup.form.required.location'
                | translate
            }}
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <!-- Meeting Link Field -->
    <div class="row" *ngIf="meetingType === MEETING_OPTIONS.ONLINE">
      <div class="col-md-12">
        <mat-form-field style="width: 100%" appearance="fill">
          <mat-label>
            {{
              'submissions.arrange-technical-interview-popup.form.link'
                | translate
            }}
          </mat-label>
          <input
            placeholder="{{
              'submissions.arrange-technical-interview-popup.form.link-placeholder'
                | translate
            }}"
            matInput
            formControlName="meeting_link"
          />
          <mat-error
            *ngIf="
              arrangeTechnicalInterviewFormGroup.controls.meeting_link.hasError(
                'required'
              )
            "
          >
            {{
              'submissions.arrange-technical-interview-popup.form.required.link'
                | translate
            }}
          </mat-error>
          <mat-error
            *ngIf="
              arrangeTechnicalInterviewFormGroup.controls.meeting_link.hasError(
                'pattern'
              )
            "
          >
            {{
              'apps.create-new-app.connection.app-url-pattern-error' | translate
            }}
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </form>
</div>

<mat-dialog-actions align="end" class="action-buttons">
  <button mat-button mat-dialog-close>
    {{ 'widgets.panel.cancel' | translate }}
  </button>
  <button
    mat-raised-button
    color="primary"
    (click)="onClickClose()"
    matTooltip="{{
      'submissions.reassign-and-reschedule-interview-popup.form.save'
        | translate
    }}"
  >
    {{
      'submissions.reassign-and-reschedule-interview-popup.form.save'
        | translate
    }}
  </button>
</mat-dialog-actions>
